import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newPackagesModalRef",
  id: "kt_modal_import_packages",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_import_packages_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_import_packages_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_import_packages_header",
  "data-kt-scroll-wrappers": "#kt_modal_import_packages_scroll",
  "data-kt-scroll-offset": "500px"
}
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = {
  key: 0,
  class: "loading-bar d-flex justify-content-center align-items-center"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "d-flex col-lg-12 fv-row" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "fv-plugins-message-container position-absolute top-10 start-50" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-4 mt-4 d-flex justify-content-center" }
const _hoisted_21 = { class: "badge badge-light-danger me-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Invalid", -1)
const _hoisted_23 = { class: "badge badge-light-success me-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Success", -1)
const _hoisted_25 = { class: "badge badge-light me-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Total", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-4 mt-4 badge badge-light-danger" }, " The following packages have a wrong Area name please add the correct Area and save ", -1)
const _hoisted_28 = { class: "mt-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Holder Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Document ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Phone"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5 text-nowrap" }, "Missing Areas"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-5" }, "Areas")
  ])
], -1)
const _hoisted_30 = { class: "p-5" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "p-5" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "p-5" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "p-5" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "p-5" }
const _hoisted_43 = { class: "p-5" }
const _hoisted_44 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "modal-footer flex-center" }
const _hoisted_49 = {
  type: "reset",
  "data-bs-dismiss": "modal",
  id: "kt_modal_import_packages_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_50 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_import_packages_submit",
  class: "btn btn-primary"
}
const _hoisted_51 = { class: "indicator-label" }
const _hoisted_52 = { class: "indicator-progress" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_import_packages_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.paymentSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.translate('importPackages')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("progress", {
                          max: "50",
                          value: _ctx.progressValue
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Form, {
                    class: "form",
                    id: "kt_modal_import_packages_form",
                    onSubmit: _ctx.onSubmitPull
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('attachment')), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_Field, {
                            type: "file",
                            ref: "attachmentField",
                            accept: ".pdf,application/pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,",
                            autocomplete: "off",
                            class: "form-control form-control-solid",
                            placeholder: _ctx.translate('propertyAttachments'),
                            name: "attachment",
                            modelValue: _ctx.packageFile,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.packageFile) = $event))
                          }, null, 8, ["placeholder", "modelValue"]),
                          _createElementVNode("button", {
                            type: "submit",
                            id: "kt_account_profile_details_submit",
                            ref: "submitPullButton",
                            class: "btn btn-primary flex-shrink-0",
                            disabled: _ctx.isButtonDisabled
                          }, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate('import')), 1)
                          ], 8, _hoisted_15)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_ErrorMessage, { name: "url" })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]),
                  (
                    _ctx.packages &&
                    _ctx.packages.invalidPackages &&
                    _ctx.packages.invalidPackages.length > 0
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.packages.invalidPackagesCount), 1),
                            _hoisted_22
                          ]),
                          _createElementVNode("span", _hoisted_23, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.packages.sucssesPackagesCount), 1),
                            _hoisted_24
                          ]),
                          _createElementVNode("span", _hoisted_25, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.packages.sucssesPackagesCount +
                          _ctx.packages.invalidPackagesCount), 1),
                            _hoisted_26
                          ])
                        ]),
                        _hoisted_27,
                        _createElementVNode("table", _hoisted_28, [
                          _hoisted_29,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages.invalidPackages, (input, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_30, [
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: 'packages[' + index + '].holderName',
                                    class: "form-control form-control-solid",
                                    placeholder: _ctx.translate('holderName'),
                                    onChange: ($event: any) => (input.holderName = $event.target.value),
                                    modelValue: input.holderName,
                                    "onUpdate:modelValue": ($event: any) => ((input.holderName) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_ErrorMessage, {
                                        name: 'packages[' + index + '].holderName'
                                      }, null, 8, ["name"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_33, [
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: 'packages[' + index + '].address',
                                    class: "form-control form-control-solid",
                                    placeholder: _ctx.translate('address'),
                                    onChange: ($event: any) => (input.address = $event.target.value),
                                    modelValue: input.address,
                                    "onUpdate:modelValue": ($event: any) => ((input.address) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createVNode(_component_ErrorMessage, {
                                        name: 'packages[' + index + '].address'
                                      }, null, 8, ["name"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_36, [
                                  _createVNode(_component_Field, {
                                    type: "text",
                                    name: 'packages[' + index + '].docId',
                                    class: "form-control form-control-solid",
                                    placeholder: _ctx.translate('docId'),
                                    onChange: ($event: any) => (input.docId = $event.target.value),
                                    modelValue: input.docId,
                                    "onUpdate:modelValue": ($event: any) => ((input.docId) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_ErrorMessage, {
                                        name: 'packages[' + index + '].docId'
                                      }, null, 8, ["name"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_39, [
                                  _createVNode(_component_Field, {
                                    type: "number",
                                    name: 
                              'packages[' + index + '].recipientPhoneNumber'
                            ,
                                    placeholder: _ctx.translate('phoneNumber'),
                                    class: "form-control form-control-solid",
                                    onChange: ($event: any) => (
                              input.recipientPhoneNumber = $event.target.value
                            ),
                                    modelValue: input.recipientPhoneNumber,
                                    "onUpdate:modelValue": ($event: any) => ((input.recipientPhoneNumber) = $event)
                                  }, null, 8, ["name", "placeholder", "onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, [
                                      _createVNode(_component_ErrorMessage, {
                                        name: 
                                  'packages[' + index + '].recipientPhoneNumber'
                                
                                      }, null, 8, ["name"])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_42, _toDisplayString(input.area), 1),
                                _createElementVNode("td", _hoisted_43, [
                                  _createVNode(_component_Field, {
                                    as: "select",
                                    name: 'packages[' + index + '].areaId',
                                    class: "form-select form-select-solid form-select-lg text-capitalize",
                                    onChange: ($event: any) => (input.areaId = $event.target.value),
                                    modelValue: input.areaId,
                                    "onUpdate:modelValue": ($event: any) => ((input.areaId) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.translate('selectArea')), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: area.id,
                                          value: area.id
                                        }, _toDisplayString(area.title?.find(
                                    (i) => i.languageCode === 'en'
                                  ).title), 9, _hoisted_45))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["name", "onChange", "modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _createVNode(_component_ErrorMessage, {
                                        name: 'packages[' + index + '].areaId'
                                      }, null, 8, ["name"])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", _hoisted_49, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_52, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_53
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}